export const API_URL = process.env.VUE_APP_API_URL || ''
export const API_URL_BOT_PROCESS = process.env.VUE_APP_API_URL_BOT_PROCESS || ''
export const CHATBOT_CUSTOMER = process.env.VUE_APP_STUB_CHATBOT_CUSTOMER || ''
export const CAPTCHA_KEY = process.env.VUE_APP_CAPTCHA_KEY|| ''
export const CAPTCHA_V3_KEY = process.env.VUE_APP_CAPTCHA_V3_KEY|| ''
export const MERCHANT = process.env.VUE_APP_STUB_MERCHANT || ''
export const MERCHANT_API_KEY = process.env.VUE_APP_STUB_MERCHANT_API_KEY ||''
export const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH || ''
export const SCRIPT_NACCC = process.env.VUE_APP_SCRIPT_NACCC || ''
export const SINGPASS_LOGIN_URL = process.env.VUE_APP_SINGPASS_LOGIN_URL || ''
export const REDIRECT_URL_NACCC = process.env.VUE_APP_REDIRECT_URL_NACCC || ''
export const REDIRECT_URL_CP = process.env.VUE_APP_REDIRECT_URL_CP || ''
export function isDotdigitalEnabled(value: string | undefined): boolean {
  return value === 'true'
}

export const DOTDIGITAL_ENABLED = isDotdigitalEnabled(process.env.VUE_APP_DOTDIGITAL_ENABLED)
export const DOTDIGITAL_TAG_SRC = process.env.VUE_APP_DOTDIGITAL_TAG_SRC || 'https://mail.nhb.sg/DM-6877301400-03/ddgtag.js'

export const TERM_TAGS: readonly string[] = [
  'TERM1',
  'TERM2',
  'TERM3',
  'TERM4',
  'TERM5',
  'TERM6',
  'TERM7',
  'TERM8',
  'TERM9',
  'TERM10',
  'TERM11',
  'TERM12',
  'TERM13',
  'TERM14',
  'TERM15',
  'TERM16',
  'TERM17',
  'TERM18',
  'TERM19',
  'TERM20',
]

const LEGACY_TERM_TAG_MAP: Record<string, string> = {
  'TERMONE':   'TERM1',
  'TERMTWO':   'TERM2',
  'TERMTHREE': 'TERM3',
  'TERMFOUR':  'TERM4',
  'TERMFIVE':  'TERM5',
}

export function normalizeTermTag(tag: string): string {
  return LEGACY_TERM_TAG_MAP[tag] ?? tag
}
